import React from 'react';
import {useTranslation} from 'react-i18next';
import Selector from './Selector';

const IndustrySelector = (props) => {
    const {value, onChangeValue, ...other} = props;
    const {t} = useTranslation('app');
    return (
        <Selector
            value={value}
            onChangeValue={onChangeValue}
            options={[]}
            {...other}
        />
    );
};

export default IndustrySelector;
